<div class="row">
    <!-- Área de firma -->
    <div class="col-12 mb-3">
        <small class="text-muted d-block mb-2">
            <i class="pi pi-info-circle me-1"></i>
            {{ 'SETTINGS.SIGN_PAD_HINT' | translate }}
        </small>

        <div class="card border-1 p-2 rounded-3 shadow-sm">
            <!-- Canvas container -->
            <div #canvasContainer class="signature-canvas-wrapper">
                <canvas #canvas class="signature-canvas"></canvas>
            </div>

            <!-- Botones de acción -->
            <div class="signature-actions mt-3 d-flex justify-content-between gap-2 flex-wrap">
                <div class="d-flex gap-2">
                    <p-button type="button" severity="secondary" size="small" icon="pi pi-undo" [label]="'SETTINGS.SIGN_PAD_UNDO' | translate"
                        (click)="undo()" [disabled]="!padCanUndo" />
                    <p-button type="button" severity="warn" size="small" icon="pi pi-times" [label]="'SETTINGS.SIGN_PAD_CLEAR' | translate"
                        (click)="clearPad()" [disabled]="padIsEmpty" />
                </div>
                <p-button type="button" severity="success" size="small" icon="pi pi-check" [label]="'COMMON.SAVE' | translate"
                    [loading]="loading" (click)="subirFirma()" [disabled]="padIsEmpty" />
            </div>
        </div>
    </div>

    <!-- Firma guardada -->
    @if(firmaGuardadaUrl) {
    <div class="col-12">
        <small class="text-muted d-block mb-2">
            <i class="pi pi-check-circle me-1 text-success"></i>
            {{ 'SETTINGS.SIGN_PAD_CURRENT_SIGNATURE' | translate }}
        </small>
        <div class="card border-1 p-3 rounded-3 shadow-sm">
            <div class="signature-preview">
                <img [src]="previewFirmaBase64" [attr.alt]="'SETTINGS.SIGN_PAD_SAVED_ALT' | translate" class="img-fluid" style="max-height: 150px;" />
            </div>
        </div>
    </div>
    }
</div>